<template>
  <FullCalendar
    defaultView="dayGridMonth"
    :datesRender="datesRender"
    :defaultDate="defaultDate"
    :events="events"
    :eventRender="eventRender"
    :header="header"
    :height="550"
    :locale="ptbr"
    :plugins="plugins"
    :themeSystem="'bootstrap'"
    :weekends="true"
    @dateClick="dayClick"
    @eventClick="titleClick"
  />
</template>

<script>
import bootstrapPlugin from "@fullcalendar/bootstrap";
import dayGridPlugin from "@fullcalendar/daygrid";
import FullCalendar from "@fullcalendar/vue";
import interactionPlugin from "@fullcalendar/interaction";
import ptbr from "@fullcalendar/core/locales/pt-br";
export default {
  name: "calendar",
  props: {
    datesRenderClick: {
      type: Object,
    },
    defaultDate: {
      type: String,
    },
    events: {
      type: Array,
      required: true,
    },
  },
  components: {
    FullCalendar,
  },
  data: function () {
    return {
      ptbr: ptbr,
      plugins: [dayGridPlugin, bootstrapPlugin, interactionPlugin],
      header: {
        left: "today",
        center: "title",
        right: "prev, next",
      },
    };
  },
  computed: {},
  watch: {},
  mounted() {},
  methods: {
    eventRender: function (event) {
      this.colorToday(event);
      this.alterTitle(event);
    },
    datesRender: function (e) {
      this.$emit("datesRenderClick", e);
    },
    dayClick(e) {
      this.$emit("dayClick", e);
    },
    titleClick(e) {
      this.$emit("titleClick", e);
    },
    colorToday: function (event) {
      var todayOtherMonth = event.view.el.querySelectorAll(
        ".fc-other-month.fc-today"
      );
      if (todayOtherMonth.length == 0) {
        var today = event.view.el.querySelectorAll(".fc-today")[0]; // dia de hoje

        if (today !== undefined) {
          today.classList.add("today-safe2pay-top"); //adicionar top no dia de hoje

          var index = Array.prototype.indexOf.call(
            today.parentNode.children,
            today
          ); // buscar a posição na lista do dia de hoje

          var child =
            today.parentNode.parentNode.parentNode.parentNode.parentNode;
          var parent = child.parentNode; // lista dos dias

          var indexParent = Array.prototype.indexOf.call(
            parent.children,
            child
          );
          
          parent.children[
            indexParent + 1
          ].children[0].children[0].children[0].children[0].children[
            index
          ].classList.add("today-safe2pay-top");
        }
      }
    },
    alterTitle: function (event) {
      var title = event.el.querySelector(".fc-title");
      title.innerHTML = title.textContent;
    },
  },
};
</script>

<style lang='scss'>
@import "node_modules/@fullcalendar/core/main";
@import "node_modules/@fullcalendar/daygrid/main";
.fc-toolbar {
  .fc-center:first-letter {
    text-transform: uppercase;
  }
}
.fc-event {
  border: 0px;
  background: white;
  padding: 5px;
  cursor: pointer;
}
.fc-title {
  color: #00304d;
  font-size: 10pt;
  font-weight: bold;
  padding: 1px;
}
.fc-content {
  text-overflow: ellipsis;
}
.popover-body {
  font-size: 10pt;
  font-weight: bold;
}
.fc-today {
  color: #5a6169;
  background: white; //00304d77
}
.today-safe2pay-top {
  border-top: solid !important;
  border-top-color: #00304d !important;
  border-top-width: 5px !important;
}
.status-contacorrente {
  font-size: 9pt !important;
  font-weight: 400 !important;
  color: gray !important;
  float: left;
  vertical-align: bottom;
}
</style>



// WEBPACK FOOTER //
// src/components/common/calendar.vue